<div class="grid">
  <greco-tile *ngFor="let tile of tiles$ | async" [tile]="tile" (refresh)="refreshed($event)"></greco-tile>
</div>
